// extracted by mini-css-extract-plugin
export var countdownContainer = "index-module--countdownContainer--24IF1";
export var countdownWidet = "index-module--countdownWidet--nvp6i";
export var countdownText = "index-module--countdownText--11CAq";
export var burger = "index-module--burger--_3K9L";
export var burgerContainer = "index-module--burgerContainer--c-UFf";
export var countdownClock = "index-module--countdownClock--1C3Tt";
export var flickerAnimation = "index-module--flickerAnimation--2ijWr";
export var emailLink = "index-module--emailLink--1u1Zg";